import { render } from "./ViewLanding.vue?vue&type=template&id=5e3ff04a&scoped=true"
import script from "./ViewLanding.vue?vue&type=script&lang=js"
export * from "./ViewLanding.vue?vue&type=script&lang=js"

import "./ViewLanding.vue?vue&type=style&index=0&id=5e3ff04a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3ff04a"]])

export default __exports__